import {
  ArrowRight,
  DataBase,
  Network_2 as NetworkIcon,
  UserFollow,
} from '@carbon/icons-react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Body,
  Button,
  IconComponentType,
} from 'vet-bones/design-system/components';

import {
  DASHBOARD_MANAGE_DATABRICKS,
  DASHBOARD_MANAGE_ENDPOINTS,
  DASHBOARD_MANAGE_ENDPOINT_USERS,
} from 'src/ui/constants/testIds';
import * as copy from 'src/ui/templates/copy';

interface QuickActionsProps {
  index: number;
  org: string | undefined;
  showManageEndpointUsers: boolean;
  showManageDatabricks: boolean;
  showManageEndpoints: boolean;
}

interface QuickAction {
  icon: IconComponentType;
  label: string;
  show: boolean;
  testId: string;
  to?: string;
}

export const QuickActions: React.VFC<QuickActionsProps> = ({
  index,
  org,
  showManageEndpointUsers,
  showManageDatabricks,
  showManageEndpoints,
}) => {
  const history = useHistory();
  const {
    manageEndpointUsers,
    manageEndpoints,
    manageDatabricks,
  } = copy.components.dashboard.quickActions;

  const actions: QuickAction[] = [
    {
      icon: UserFollow,
      label: manageEndpointUsers,
      show: showManageEndpointUsers,
      testId: DASHBOARD_MANAGE_ENDPOINT_USERS,
      to: org ? `/o/${org}/connections/${index}` : `/connections/${index}`,
    },
    {
      icon: NetworkIcon,
      label: manageEndpoints,
      show: showManageEndpoints,
      testId: DASHBOARD_MANAGE_ENDPOINTS,
      to: org ? `/o/${org}/connections` : '/connections',
    },
    {
      icon: DataBase,
      label: manageDatabricks,
      show: showManageDatabricks,
      testId: DASHBOARD_MANAGE_DATABRICKS,
      to: '/databricks-partner-home',
    },
  ];

  const visibleActions = actions.filter((action) => action.show);

  if (!visibleActions.length) {
    return null;
  }

  return (
    <div className="quick-actions-card">
      <Body className="quick-actions-card-header" size="sm" weight="semibold">
        {copy.components.dashboard.quickActionsTitle}
      </Body>
      <div className="quick-actions-rows">
        {visibleActions.map((action) => (
          <Button
            key={action.testId}
            className="quick-action-button"
            leftIcon={action.icon}
            leftIconProps={{ className: 'quick-action-icon' }}
            onClick={() => action.to && history.push(action.to)}
            rightIcon={ArrowRight}
            rightIconProps={{ className: 'quick-action-arrow', size: 'sm' }}
            size="md"
            testId={action.testId}
            variant="ghost-accent"
          >
            <div className="quick-action-label">{action.label}</div>
          </Button>
        ))}
      </div>
    </div>
  );
};
